import { RouteNavigation } from "@denshya/navigation"

import fileRouter from "../router/file-router"


const globalNavigation = new RouteNavigation(fileRouter)
export default globalNavigation
